<div id="collection-access-dialog" class="dialog">
    <div class=" dialog-title">
      <h2>{{ 'collection.access'|translate }}</h2>
            <button mat-icon-button (click)="close()">
                <mat-icon  fontIcon="close"></mat-icon>
            </button>
    </div>
    <mat-dialog-content>
        @if (collection.access.length > 0) {
        <div id="collection-access-list">

                @for (access of collection.access; track access.id) {
                    <div class="access-entry">
                        <span>{{ access.user.fullName }}</span>
                        <span>
                            <button mat-button
                                    [matMenuTriggerFor]="accessAction">
                                {{ 'collection.access.' + access.permission|translate }}
                            </button>
                            <mat-menu #accessAction>
                                <button mat-menu-item (click)="changeAccess(access.id, 'view')">
                                    {{ 'collection.access.view'|translate }}
                                </button>
                                <button mat-menu-item (click)="changeAccess(access.id, 'download')">
                                    {{ 'collection.access.download'|translate }}
                                </button>
                                 <button mat-menu-item (click)="changeAccess(access.id, 'edit')">
                                    {{ 'collection.access.edit'|translate }}
                                </button>
                                <button mat-menu-item (click)="changeAccess(access.id, 'manage')">
                                    {{ 'collection.access.manage'|translate }}
                                </button>
                                <button mat-menu-item (click)="removeAccess(access.id)">
                                    {{ 'collection.access.revoke'|translate }}
                                </button>
                            </mat-menu>
                        </span>
                    </div>
                }
        </div>
        } @else {
            {{ 'collection.access.empty'|translate }}
        }
        @if (error) {
            <div class="error">
                {{ 'collection.access.error'|translate }}
            </div>
        }
    </mat-dialog-content>
</div>
